/**
 * Chemin secret de connexion admin.
 * Défini dans REACT_APP_ADMIN_PATH (.env).
 * Ne jamais exposer ce chemin sur le site public.
 */
export const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || 'gestion-csg';
